/// <reference path="../types/index.d.ts" />

import '../client_forms/tcanewportevent/style.css';
import FormStructure from './tcanewportevent/form_structure';

export default FormStructure;